'use client';


export default function NotFound() {

  return (

    <div style={{ padding: 24 }}>

      <h1>Page not found</h1>

      <p>The page you’re looking for doesn’t exist.</p>

      <a href="/" style={{ color: "blue" }}>Go home</a>

    </div>

  );

}

